export const UV = "UV";
export const V = "V";
export const IV = "IV";
export const NC = "NC";

export const ASMES = [UV, V, IV, NC] as const;
export type Asme = (typeof ASMES)[number];
